const params = new URLSearchParams(window.location.search);

let page_vars={};
for (const [key, value] of params.entries())
	page_vars[key]=value;

let page_lng="es";

const data_url="1y_4Ia2Lj-ZJUPFPoO_Zpb-qGTrSlUbj4lVQk8nkDkoE";
let data={events:null,comments:null};


const server_url= location.hostname === "localhost" 
? "http://localhost:8080"
: "https://server.ardilla.ai";

function show_lng(lng)
{
	document.querySelectorAll(".lng").forEach(element=>{
		element.style.display = 'none';
	});
	document.querySelectorAll(".lng_"+lng).forEach(element=>{
		element.style.display = 'inline';
	});	
	page_lng=lng;
	localStorage["wircos_lng"]=lng;
}
	
async function load()
{
	show_lng(page_lng)
	document.querySelectorAll(".btn_lng").forEach(element=>{
		element.addEventListener('click', lng_click,false);
	});

	if(document.getElementById("header"))
		document.getElementById("header").classList.remove("header_hide");

	document.querySelectorAll(".faq_question").forEach(element=>{
		element.addEventListener('click', function(e)
		{			
			e.preventDefault();
			this.classList.toggle("faq_arrow_extend");
			this.nextElementSibling.classList.toggle("faq_answer_visible");
		},false);
	});

	const nav=document.querySelector("nav");
	if(nav)
	{
		window.addEventListener("scroll",(event)=>
		{
			if(window.scrollY>50)
				nav.classList.add("scroll");
			else 
				if(nav.classList.contains("scroll")) nav.classList.remove("scroll");
		});
	}

	document.getElementById("btn_contact").addEventListener("click",async e=>{
		e.preventDefault();
		const form=document.getElementById("contact_form");
		const fields=form.querySelectorAll("input");
		fields.forEach(el=>{
			
			if(el.checkValidity())
			{
				if(el.type === 'checkbox')
					el.parentElement.classList.remove("error");
				else
					el.classList.remove("error");
			}else{ 	
				if(el.type === 'checkbox')
					el.parentElement.classList.add("error");
				else
					el.classList.add("error");
				}
		});
		if(!form.querySelector(".error"))
		{
			try
			{
				console.log(server_url+"/business/request_demo");
				const res = await fetch(server_url+"/business/request_demo",
					{ 
						method: 'post',
						mode: "cors",
						headers:{'Accept': 'application/json','Content-Type': 'application/json'},
						body:JSON.stringify({
							contact_name:document.getElementById("contact_name").value,
							contact_email:document.getElementById("contact_email").value,
							contact_company:document.getElementById("contact_company").value
						})
					});	
	
				console.log(res);

				const json=await res.json();
				if(!json) throw new Error("server_error");
				if(!json.status) throw new Error("server_error");
	
				document.querySelector(".contact_result_ok").classList.remove("hide");
				document.querySelector(".contact_result_ko").classList.add("hide");
				e.target.classList.add("hide");
			}catch(e){
				console.log(e);
			   document.querySelector(".contact_result_ko").classList.remove("hide");
			}
		}	
	});

	document.querySelectorAll("[aria-target").forEach(el=>{
		el.addEventListener("click",e=>{
			e.preventDefault();
			document.querySelector(".btn_check_option.selected").classList.remove("selected");
			el.classList.add("selected");
			document.querySelectorAll("[target-type]").forEach(target=>{
				if(target.getAttribute("target-type")===el.getAttribute("aria-target"))
					target.classList.remove("hide");
				else
					target.classList.add("hide");
			});
		});
	});

}
	


document.addEventListener("DOMContentLoaded", load, false);

